<div>
  <select #format (change)="changeFormat(format.value)"
    style="border-style: none; color: rgb(102, 102, 102); background: transparent; text-transform: uppercase;">
    <option value="1">PDF</option>
    <option value="2">PPTX</option>
  </select>
  <button class="btn-form-control" (click)=ReloadDashboard()>Export</button>
  <img src="../../../../assets/images/loading.gif" alt="loading" style="width: 20px;" *ngIf="descargado">
</div>

<div id="message-update" style="display: none;">
  <div class="success-msg message-text">
    <i class="fa fa-check"></i>
    Last update: {{lastUpdate}}
  </div>
</div>

<div #blur class="grilla">
  <div id="truckefficiency" style=" width: 100%;" [ngStyle]="{ 'height': '88vh' }" #reportContainer></div>
</div>

<div id="modal-focus" #popup class="popup modal" tabindex="-1">
  <div class="close">
    <span (click)=closeModal()>X</span>
  </div>
  <div>
    <neoris-trip-detail [response]="response"></neoris-trip-detail>
  </div>
</div>

<div id="modalDetailGD" class="modal">
  <span (click)="closeModalDetail()" class="close">&times;</span>
  <div class="detail-truck">
    <div class="title-detail-truck">
      <span class="title-rt">Detail information​</span>
    </div>
    <div class="header-detail-truck">
      <div class="first-item">
        <div class="bold">Plant:</div>
        <div>{{responseDetail?.plant}} - #{{responseDetail?.code}}</div>
        <div class="bold">Date:</div>
        <div>{{responseDetail?.actualStart|ordinalDate}}</div>
      </div>
      <div class="fifty-percent">
        <form [formGroup]="detailTruckForm" (ngSubmit)="UpdateDetailTruck(detailTruckForm.value)">
          <div>
            <span class="bold">Vehicle</span>
          </div>
          <div class="second-item">
            <div class="filter">
              <div class="small-letter">License plate:</div>
              <div>
                <input (keyup)="onKeyLP($event)" formControlName="plateNumber" [disabled]="true" class="input-control"
                  type="text" value="{{responseDetail?.platE_NUMBER}}" maxlength="10">
              </div>
            </div>
            <div class="filter">
              <div class="small-letter">Truck#:​</div>
              <div>
                <input (keyup)="onKeyTN($event)" formControlName="truckNumber" [disabled]="_edit" class="input-control"
                  type="text" value="{{responseDetail?.truckNumber}}" maxlength="10">
              </div>
            </div>
            <div class="filter">
              <div class="small-letter">Company:​</div>
              <div>
                <select formControlName="govNumber" #company (change)="changeCompany(company.value)" [disabled]="_edit"
                  class="select-control">
                  <option *ngFor="let company of companies" [selected]="company.selected === true"
                    value="{{company.govNumber}}">
                    {{company.name}}</option>
                </select>
              </div>
            </div>
            <div class="filter">
              <div class="small-letter">DOT#:​</div>
              <div>
                <input (keyup)="onKeyDN($event)" formControlName="dotNumber" id="dotNumber" [disabled]="_edit"
                  class="input-control" type="text" value="{{responseDetail?.dotNumber}}" maxlength="10">
              </div>
            </div>
            <div class="filter">
              <div class="small-letter">Type:​</div>
              <div>
                <select formControlName="attributeValue" #hola (change)="changeType(hola.value)" [disabled]="_edit"
                  class="select-control">
                  <option *ngFor="let av of types" [selected]="av.selected === true" value="{{av.id}}">
                    {{av.nameEn}}
                  </option>
                </select>
                <!-- <select formControlName="attributeValue" #type (change)="changeType(type.value)" [disabled]="_edit"
                  class="select-control">
                  <option *ngFor="let av of types" [selected]="av.selected === true" value="{{av.id}}">
                    {{av.nameEn}}
                  </option>
                </select>​​ -->
              </div>
            </div>
          </div>
          <div class="second-item">
            <div>
              <button class="button-control" *ngIf="_edit" (click)="edit()">Edit</button>
              <button class="button-control" type="submit" *ngIf="!_edit">Save</button>
            </div>
          </div>
        </form>
      </div>
      <div id="resolution" class="resolution" style="display: none;">
        <div class="success-msg">
          <i class="fa fa-check"></i>
          Updated successfully.
        </div>
      </div>
      <div>
        <div class="first-item">
          <div>Completed trips today:</div>
          <div>{{responseDetail?.amountofjourneys}}</div>
        </div>
        <div class="first-item">
          <div>Avg time of completed trips today:</div>
          <div>{{responseDetail?.avG_TIME}}</div>
        </div>
      </div>
    </div>
    <div class="body-detail-truck">
      <div>
        <div class="tercer-item">
          <span class="bold">Arrival at plant:​</span>
        </div>
        <div class="tercer-item">
          <table class="table-control">
            <tr>
              <th>Facility point​​</th>
              <th>Time</th>
              <th>Cycle Time​</th>
              <th>Truck</th>
              <th>License</th>
              <th>Truck #</th>
              <th>DOT</th>
              <th>Company</th>
            </tr>
            <tr *ngFor="let checkPoint of arribalAtPlant">
              <td>{{checkPoint.steP_NAME}}</td>
              <td>{{checkPoint.averagE_MINUTES_HHMM}}</td>
              <td>{{checkPoint.averagE_TIME}}</td>
              <td>
                <div *ngIf="checkPoint.image_truck?.length > 0" (click)="zoom(checkPoint.image_truck)"
                  class="container-carrusel">
                  <div>
                    <img neorisBrokenImage class="small-image" src="{{checkPoint.image_truck[0]}}" alt="">
                  </div>
                  <div class="container-carrusel-more">
                    <div class="more-images"></div>
                    <div class="more-images"></div>
                    <div class="more-images"></div>
                  </div>
                </div>
              </td>
              <td>
                <img *ngIf="checkPoint.image_license?.length > 0" neorisBrokenImage
                  (click)="zoom(checkPoint.image_license)" class="small-image" src="{{checkPoint.image_license[0]}}"
                  alt="">
              </td>
              <td>
                <img *ngIf="checkPoint.image_truck_number?.length > 0" neorisBrokenImage
                  (click)="zoom(checkPoint.image_truck_number)" class="small-image"
                  src="{{checkPoint.image_truck_number[0]}}" alt="">
              </td>
              <td>
                <img *ngIf="checkPoint.image_dot?.length > 0" neorisBrokenImage (click)="zoom(checkPoint.image_dot)"
                  class="small-image" src="{{checkPoint.image_dot[0]}}" alt="">
              </td>
              <td>
                <img *ngIf="checkPoint.image_company?.length > 0" neorisBrokenImage
                  (click)="zoom(checkPoint.image_company)" class="small-image" src="{{checkPoint.image_company[0]}}"
                  alt="">
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div id="myModal" class="modal">
    <span (click)="closeModal()" class="close">&times;</span>
    <img class="modal-content" id="img01" style="display:none;">
    <div class="carousel">
      <div class="carousel__item carousel__item--visible">
        <img src="{{ImagesCheckPoint[0] || ''}}" alt="" />
      </div>
      <div class="carousel__item" *ngFor="let item of ImagesCheckPoint.slice(1)">
        <img src="{{item}}" alt="">
      </div>
      <div *ngIf="ImagesCheckPoint.length>1" class="carousel__actions">
        <button id="carousel__button--prev" aria-label="Previous slide" (click)="previousSlide()">
          < </button>
            <button id="carousel__button--next" aria-label="Next slide" (click)="nextSlide()">></button>
      </div>
    </div>
  </div>
</div>
